import { render } from "./DeptLogin.vue?vue&type=template&id=12c6cb3a&scoped=true"
import script from "./DeptLogin.vue?vue&type=script&lang=js"
export * from "./DeptLogin.vue?vue&type=script&lang=js"

import "./DeptLogin.vue?vue&type=style&index=0&id=12c6cb3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c6cb3a"]])

export default __exports__